import { ScheduledChatInfo } from '@mint-lib/ai-chat/components';
import { DividerWithText, typographyVariants } from '@mint-lib/tw-components';
import { Schedule } from '@mint-sdk/api-ai-assistant';
type Props = {
  date: string;
  scheduleDetails?: Schedule.QueryScheduleSchemaType;
};

const MessageDateSeparator = ({ date, scheduleDetails }: Props) => {
  if (scheduleDetails?.status === 'scheduled') {
    return (
      <DividerWithText>
        <ScheduledChatInfo scheduleDetails={scheduleDetails} />
      </DividerWithText>
    );
  }

  return (
    <DividerWithText decorative={false}>
      <p
        className={typographyVariants({
          variant: 'caption2',
          color: 'secondary',
        })}
      >
        {date}
      </p>
    </DividerWithText>
  );
};

export { MessageDateSeparator };
